"use client";

import { FC, useCallback, useState } from "react";
import { useRouter } from "next/navigation";
import { handleRedirection } from "../../utils/helper";
import { RecentlyViewedContent } from "./RecentlyViewedContent";
import { RecentlyViewedStockItem } from "./recentlyViewedTypes";

interface RecentlyViewedCardProps {
  stock: RecentlyViewedStockItem;
  modalTitle?: string;
  modalBtnCta?: string;
  successMsg?: string;
  errorMsg?: string;
  onCardClick?: (stock: RecentlyViewedStockItem, position: string) => void;
  position: string;
}

export const RecentlyViewedCard: FC<RecentlyViewedCardProps> = ({
  stock,
  modalTitle,
  modalBtnCta,
  successMsg,
  errorMsg,
  onCardClick,
  position,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const router = useRouter();

  const handleCardClick = useCallback(
    (e: React.MouseEvent) => {
      if (isModalOpen) {
        return;
      }

      const target = e.target as HTMLElement;
      if (
        target.closest('button[aria-label="Add to watchlist"]') ||
        target.closest(".icomoon")
      ) {
        return;
      }

      onCardClick?.(stock, position);
      handleRedirection(`/${stock.redirectURL}`, router);
    },
    [isModalOpen, onCardClick, position, router, stock],
  );

  return (
    <button
      type="button"
      onClick={handleCardClick}
      className="w-[156px] max-w-[156px] shrink-0 cursor-pointer border-0 bg-transparent p-0 text-left md:w-[215px] md:max-w-[215px]"
      aria-label={`View details for ${stock.fullName || stock.symbol || "stock"}`}
    >
      <div className="box-border flex w-full flex-col rounded-[8px] border border-[#F2F2F2] bg-white p-3">
        <RecentlyViewedContent
          stock={stock}
          onModalStateChange={setIsModalOpen}
          modalTitle={modalTitle}
          modalBtnCta={modalBtnCta}
          successMsg={successMsg}
          errorMsg={errorMsg}
        />
      </div>
    </button>
  );
};

export default RecentlyViewedCard;
